import GlobalIconSvg from "../../assets/GlobalIconSvg";

export const HeaderDisplay = ({
    setShowModal,
    countryName,
    countryCode,
    languageName,
    regionName,
}) => {
    const showModalHandler = () => setShowModal((e) => !e);

    return (
        <div
            className="flex items-center space-x-2 cursor-pointer text-left"
            onClick={showModalHandler}
        >
            <span className="text-lg rounded-lg relative top-[-5px]">
                {countryName !== "global" ? (
                    <i className={`fi fi-${countryCode?.toLowerCase()}`}></i>
                ) : (
                    <GlobalIconSvg />
                )}
            </span>

            <div className="flex flex-col leading-tight">
                <span className="text-sm font-medium text-black capitalize">
                    {`${countryName}${regionName ? ` (${regionName})` : ""}`}
                    <i className="pi pi-chevron-right text-gray text-[12px] ml-2 relative"></i>
                </span>
                <span className="text-[12px] text-gray-500 capitalize">({languageName})</span>
            </div>
        </div>
    );
};
